const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
const NANO_ID_RE = /^[a-z0-9]{6}$/
const FIREBASE_UID_RE = /^[a-zA-Z0-9]{20,128}$/

export const isValidUUID = (id: string): boolean => UUID_RE.test(id)

export const isValidNanoId = (id: string): boolean => NANO_ID_RE.test(id)

export const isValidFirebaseUID = (id: string): boolean =>
  FIREBASE_UID_RE.test(id)

/**
 * Accepts either a UUID or a Firebase UID — covers entity IDs that could
 * come from either source (e.g. user pages where the param could be a
 * Firebase UID or a UUID depending on the entity).
 */
export const isValidEntityId = (id: string): boolean =>
  isValidUUID(id) || isValidFirebaseUID(id)
